import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class Google extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 22 14"
        width={width}
      >
        <g
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          transform="translate(-46.000000, -218.000000)"
        >
          <g transform="translate(28.000000, 204.000000)">
            <g transform="translate(18.000000, 14.000000)">
              <path
                d="M15.68,8.18181818 C15.68,7.61454545 15.6290909,7.06909091 15.5345455,6.54545455 L8,6.54545455 L8,9.64 L12.3054545,9.64 C12.12,10.64 11.5563636,11.4872727 10.7090909,12.0545455 L10.7090909,14.0618182 L13.2945455,14.0618182 C14.8072727,12.6690909 15.68,10.6181818 15.68,8.18181818 L15.68,8.18181818 Z"
                fill="#4285F4"
              />
              <path
                d="M8,16 C10.16,16 11.9709091,15.2836364 13.2945455,14.0618182 L10.7090909,12.0545455 C9.99272727,12.5345455 9.07636364,12.8181818 8,12.8181818 C5.91636364,12.8181818 4.15272727,11.4109091 3.52363636,9.52 L0.850909091,9.52 L0.850909091,11.5927273 C2.16727273,14.2072727 4.87272727,16 8,16 L8,16 Z"
                fill="#34A853"
              />
              <path
                d="M3.52363636,9.52 C3.36363636,9.04 3.27272727,8.52727273 3.27272727,8 C3.27272727,7.47272727 3.36363636,6.96 3.52363636,6.48 L3.52363636,4.40727273 L0.850909091,4.40727273 C0.309090909,5.48727273 0,6.70909091 0,8 C0,9.29090909 0.309090909,10.5127273 0.850909091,11.5927273 L3.52363636,9.52 L3.52363636,9.52 Z"
                fill="#FBBC05"
              />
              <path
                d="M8,3.18181818 C9.17454545,3.18181818 10.2290909,3.58545455 11.0581818,4.37818182 L13.3527273,2.08363636 C11.9672727,0.792727273 10.1563636,0 8,0 C4.87272727,0 2.16727273,1.79272727 0.850909091,4.40727273 L3.52363636,6.48 C4.15272727,4.58909091 5.91636364,3.18181818 8,3.18181818 L8,3.18181818 Z"
                fill="#EA4335"
              />
            </g>
          </g>
        </g>
      </SVGElement>
    );
  }
}
